<template>
  <b-row
    v-show="!loading"
    class="mb-2"
  >
    <b-col
      cols="12"
      sm="6"
      class="d-flex align-items-center justify-content-center justify-content-sm-start"
    >
      <span class="text-muted ml-1">نمایش {{
        ((page - 1) * perPage) + 1
      }} تا {{
        page * perPage > totalRows ? totalRows : page * perPage
      }} از {{ totalRows }} مورد</span>

      <v-select
        :value="perPage"
        :options="perPageOptions"
        :clearable="false"
        :searchable="false"
        dir="rtl"
        class="per-page-select"
        @input="changePerPage"
      />
    </b-col>
    <b-col
      cols="12"
      sm="6"
      class="d-flex align-items-center justify-content-center justify-content-sm-end"
    >

      <b-dropdown
        ref="dropdown"
        class="jump-to"
        variant="link"
      >
        <template #button-content>
          <feather-icon
            icon="ChevronUpIcon"
            size="18"
          />
        </template>

        <b-col class="py-1">
          <b-form-group
            label="شماره صفحه"
            label-for="page"
            @submit.stop.prevent
          >
            <b-form-input
              id="page"
              ref="page"
              size="sm"
              type="number"
              :value="page"
              @keyup.enter="jump"
            />
          </b-form-group>
          <b-button
            variant="primary"
            size="sm"
            @click="jump"
          >اعمال</b-button>
        </b-col>
      </b-dropdown>

      <b-pagination
        v-model="page"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
        @change="update"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
      </b-pagination>

    </b-col>

  </b-row>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    totalRows: {
      type: Number,
      default: 1000 * 1000,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perPageOptions: [5, 10, 15, 20, 50],
    }
  },
  methods: {
    update(pageNumber) {
      this.$emit('change', pageNumber)
    },
    changePerPage(value) {
      if (value == null || value === this.perPage) return
      this.$emit('update:perPage', value)
      this.update(1)
    },
    jump() {
      const number = parseInt(this.$refs.page.$el.value)
      this.$refs.dropdown.hide(true)
      this.update(number)
    },
  },
}
</script>

<style scoped>
.per-page-select {
  min-width: 90px;
}
</style>
